module.exports = require('./lib/clean');



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/index.js
// module id = 2274
// module chunks = 0